import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { selectors as apiSelectors } from 'zender-api-client';

import * as appSelectors from '../../../../../../selectors';

import Results from './Results.component';

const QuizResultsContainer = props => <Results {...props} />;

const mapStateToProps = state => ({
	locale: appSelectors.locale.localeSelector(state),
	count: apiSelectors.quiz.latestQuizWinnersCountSelector(state),
	winners: apiSelectors.quiz.latestQuizWinnersSelector(state),
	prizePerUser: apiSelectors.quiz.latestQuizPrizePerUserSelector(state),
	quizConfig: apiSelectors.target.quizConfigSelector(state),
	theming: appSelectors.ui.themingSelector(state),
});

const mapDispatchToProps = () => ({});

QuizResultsContainer.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(QuizResultsContainer);



// WEBPACK FOOTER //
// ./src/ui/interaction/children/quiz/children/results/Results.container.js